<template>
  <StoreLanding />
</template>

<script setup lang="ts">
definePageMeta({ layout: 'editorial' })
</script>
